/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamExamidLangsAvailableQueryResponse,
  GetApiV1ExamExamidLangsAvailablePathParams,
  GetApiV1ExamExamidLangsAvailable401,
  GetApiV1ExamExamidLangsAvailable404,
  GetApiV1ExamExamidLangsAvailable500,
} from "../../types/examEvaluationController/GetApiV1ExamExamidLangsAvailable.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamidLangsAvailable } from "../../clients/examEvaluationController/getApiV1ExamExamidLangsAvailable.ts";

export const getApiV1ExamExamidLangsAvailableQueryKey = (
  examId: GetApiV1ExamExamidLangsAvailablePathParams["examId"],
) =>
  [
    { url: "/api/v1/exam/:examId/langs/available", params: { examId: examId } },
  ] as const;

export type GetApiV1ExamExamidLangsAvailableQueryKey = ReturnType<
  typeof getApiV1ExamExamidLangsAvailableQueryKey
>;

export function getApiV1ExamExamidLangsAvailableQueryOptions(
  examId: GetApiV1ExamExamidLangsAvailablePathParams["examId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamidLangsAvailableQueryKey(examId);
  return queryOptions<
    GetApiV1ExamExamidLangsAvailableQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamidLangsAvailable401
      | GetApiV1ExamExamidLangsAvailable404
      | GetApiV1ExamExamidLangsAvailable500
    >,
    GetApiV1ExamExamidLangsAvailableQueryResponse,
    typeof queryKey
  >({
    enabled: !!examId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamidLangsAvailable(examId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de idiomas suportados que ainda não foram adicionados à prova informada, para uso em componentes de seleção ao criar um novo idioma. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas disponíveis para uma prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examId/langs/available}
 */
export function useGetApiV1ExamExamidLangsAvailable<
  TData = GetApiV1ExamExamidLangsAvailableQueryResponse,
  TQueryData = GetApiV1ExamExamidLangsAvailableQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamidLangsAvailableQueryKey,
>(
  examId: GetApiV1ExamExamidLangsAvailablePathParams["examId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamExamidLangsAvailableQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamExamidLangsAvailable401
          | GetApiV1ExamExamidLangsAvailable404
          | GetApiV1ExamExamidLangsAvailable500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamExamidLangsAvailableQueryKey(examId);

  const query = useQuery(
    {
      ...getApiV1ExamExamidLangsAvailableQueryOptions(examId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamExamidLangsAvailable401
      | GetApiV1ExamExamidLangsAvailable404
      | GetApiV1ExamExamidLangsAvailable500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
